import { FCX } from "@datassential/platform-ui-lib";
import { ISocialPost } from "@models/SocialPosts";
import SocialPosts from "@components/SocialPosts/SocialPosts";

const FoodSocialPosts: FCX<{
    data: ISocialPost[];
    word: string;
    association: string;
    isLoading: boolean;
}> = ({
    data,
    word,
    association,
    isLoading,
}) => {
    return (
        <SocialPosts
            data={data}
            isLoading={isLoading}
            word={word}
            association={association}
            blurClassName="FoodSectionSocial__blur"
        />
    );
};

export default FoodSocialPosts;
